// Amplify (Cognito) configuration for per-user auth.
//
// Values come from the CloudFormation Outputs (CognitoUserPoolId /
// CognitoUserPoolClientId) wired in as REACT_APP_* env vars. If they're not
// set, configuration is skipped and the app keeps running on the legacy
// shared-token path — so this can land before Cognito is deployed without
// breaking local/dev.
import {Amplify} from "aws-amplify";
import {cognitoUserPoolsTokenProvider} from "aws-amplify/auth/cognito";
import {sessionStorage} from "aws-amplify/utils";

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const userPoolClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

export const isCognitoConfigured = Boolean(userPoolId && userPoolClientId);

if (isCognitoConfigured) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        // Passwordless OTP via custom-auth challenge — no username/password.
        loginWith: {phone: true, email: true},
      },
    },
  });
  // Store the id/access/refresh tokens in sessionStorage, not the Amplify
  // default of localStorage. This population uses shared/public computers
  // (libraries), where localStorage tokens survive a browser close and let
  // the next person inherit the previous user's session for the refresh
  // token's lifetime. sessionStorage scopes the tokens to the tab, matching
  // how App.js already stores the app session; the tradeoff is a re-OTP on
  // each new browser session, which is acceptable for a passwordless flow.
  cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
} else if (process.env.NODE_ENV !== "test") {
  // eslint-disable-next-line no-console
  console.warn(
    "[auth] Cognito env vars not set; running in legacy shared-token mode.",
  );
}
